//inspired by CK bold\italic basic style commands
function createBasicStyleCommand(editor, styleDefinition, contentform, cmdName) {
    var style = new CKEDITOR.style(styleDefinition);
    var styleCmd = new CKEDITOR.styleCommand(style, contentform);
    editor.attachStyleStateChange(style, function (state) {
        if (!editor.readOnly) {
            editor.getCommand(cmdName).setState(state);
        }
    });

    return styleCmd;
}

function initUnBold(editor) {
    var name = 'unBold';
    var style = {
        element: 'span',
        styles: {'font-weight': 'normal'},
        childRule: function (el) {
            return (el.$.style.textShadow === ''); //if child (el) has shadow he cannot be a child of underline
        }
    };

    var contentForm = {
        contentForms: [
            [
                'span',
                function (el) {
                    var fw = el.styles['font-weight'];
                    return fw === 'normal' || fw < 700;
                }
            ]
        ]
    };

    var cmd = createBasicStyleCommand(editor, style, contentForm, name);
    editor.addCommand(name, cmd);
}

function initUnItalic(editor) {
    var name = 'unItalic';
    var style = {
        element: 'span',
        styles: {'font-style': 'normal'},
        childRule: function (el) {
            return (el.$.style.textShadow === ''); //if child (el) has shadow he cannot be a child of underline
        }
    };

    var contentForm = {
        contentForms: [
            [
                'span',
                function (el) {
                    var fw = el.styles['font-style'];
                    return fw === 'normal';
                }
            ]
        ]
    };

    var cmd = createBasicStyleCommand(editor, style, contentForm, name);
    editor.addCommand(name, cmd);
}

export default {
    initUnBold: initUnBold,
    initUnItalic: initUnItalic
};
